/**
 * 500 Server Error Page
 * Displayed when a server error occurs
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ErrorPages.css';

const ServerError = ({ error, resetError }) => {
  const navigate = useNavigate();

  const handleRetry = () => {
    if (resetError) {
      resetError();
    }
    window.location.reload();
  };

  const handleGoHome = () => {
    if (resetError) {
      resetError();
    }
    navigate('/');
  };

  return (
    <div className="error-page server-error">
      <div className="error-page-content">
        <div className="error-illustration" aria-hidden="true">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
            {/* Server rack illustration */}
            <circle cx="100" cy="100" r="80" fill="var(--error-bg)" stroke="var(--error-danger)" strokeWidth="2" strokeDasharray="8 4"/>

            {/* Server box */}
            <rect x="55" y="50" width="90" height="100" rx="8" fill="white" stroke="var(--error-danger)" strokeWidth="3"/>

            {/* Server slots */}
            <rect x="65" y="65" width="70" height="12" rx="2" fill="var(--error-secondary)"/>
            <rect x="65" y="85" width="70" height="12" rx="2" fill="var(--error-secondary)"/>
            <rect x="65" y="105" width="70" height="12" rx="2" fill="var(--error-secondary)"/>

            {/* Status lights */}
            <circle cx="75" cy="130" r="4" fill="var(--error-danger)"/>
            <circle cx="90" cy="130" r="4" fill="var(--error-warning)"/>
            <circle cx="105" cy="130" r="4" fill="var(--error-secondary)"/>

            {/* Warning symbol */}
            <path d="M100 35 L115 60 L85 60 Z" fill="var(--error-warning)" stroke="var(--error-danger)" strokeWidth="2"/>
            <text x="100" y="55" textAnchor="middle" fontSize="14" fontWeight="bold" fill="var(--error-danger)">!</text>

            {/* Smoke/error particles */}
            <circle cx="145" cy="70" r="5" fill="var(--error-secondary)" opacity="0.5"/>
            <circle cx="150" cy="55" r="4" fill="var(--error-secondary)" opacity="0.3"/>
            <circle cx="155" cy="65" r="3" fill="var(--error-secondary)" opacity="0.4"/>
          </svg>
        </div>

        <h1 className="error-title">Something Went Wrong</h1>

        <p className="error-message">
          We're experiencing technical difficulties. Our team has been notified and is working on a fix.
        </p>

        {error && (
          <details className="error-details" open>
            <summary>Technical Details</summary>
            <pre>{error.message || String(error)}</pre>
            {error.stack && <pre className="error-stack">{error.stack}</pre>}
          </details>
        )}

        <div className="error-actions">
          <button
            className="error-btn primary"
            onClick={handleRetry}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="23 4 23 10 17 10"/>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
            </svg>
            Try Again
          </button>

          <button
            className="error-btn secondary"
            onClick={handleGoHome}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            Go Home
          </button>
        </div>

        <div className="error-help">
          <p>If this problem persists, please <a href="mailto:support@canira.io">contact support</a>.</p>
        </div>

        <p className="error-code">Error Code: 500</p>
      </div>
    </div>
  );
};

export default ServerError;
